// AccountSetup.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";

export default function AccountSetup() {
  const [settings, setSettings] = useState({
    signupLock: false,
    withdrawRequest: true,
    depositRequest: true,
    todayWork: true,
    announcement: "",
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await axios.get("https://api.earnmoney0.top/admin/account-settings");
      if (res.data.success) {
        setSettings(res.data.settings);
      }
    } catch (err) {
      console.error("Error fetching account settings:", err);
    } finally {
      setLoading(false);
    }
  };

  const toggleSetting = (key) => {
    setSettings((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleChange = (e) => {
    setSettings((prev) => ({
      ...prev,
      announcement: e.target.value,
    }));
  };

  const handleSave = async () => {
    try {
      const res = await axios.post(
        "https://api.earnmoney0.top/admin/account-settings",
        settings
      );
      if (res.data.success) {
        alert("✅ Settings saved successfully!");
      } else {
        alert("❌ Failed to save settings");
      }
    } catch (err) {
      console.error("Save failed:", err);
      alert("⚠️ Something went wrong!");
    }
  };

  if (loading) return <div style={styles.page}>Loading...</div>;

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>⚙️ ACCOUNT SET UP PANEL</h1>

      {/* SETTINGS */}
      <div style={styles.card}>
        <SettingSwitch
          label="SignUp Lock"
          enabled={settings.signupLock}
          onToggle={() => toggleSetting("signupLock")}
        />
        <SettingSwitch
          label="Withdraw Request"
          enabled={settings.withdrawRequest}
          onToggle={() => toggleSetting("withdrawRequest")}
        />
        <SettingSwitch
          label="Deposit Request"
          enabled={settings.depositRequest}
          onToggle={() => toggleSetting("depositRequest")}
        />
        <SettingSwitch
          label="Today Work"
          enabled={settings.todayWork}
          onToggle={() => toggleSetting("todayWork")}
        />
      </div>

      {/* Announcement */}
      <div style={styles.card}>
        <label style={styles.label}>Announcement Message</label>
        <textarea
          value={settings.announcement}
          onChange={handleChange}
          placeholder="Write announcement for users..."
          style={styles.textarea}
        />
      </div>

      {/* Save */}
      <button style={styles.saveBtn} onClick={handleSave}>
        💾 Save
      </button>
    </div>
  );
}

/* ===================== SWITCH COMPONENT ===================== */
function SettingSwitch({ label, enabled, onToggle }) {
  return (
    <div style={styles.switchRow}>
      <span style={styles.switchLabel}>{label}</span>
      <div
        style={{
          ...styles.switch,
          backgroundColor: enabled ? "#22c55e" : "#ef4444",
          justifyContent: enabled ? "flex-end" : "flex-start",
        }}
        onClick={onToggle}
      >
        <div style={styles.knob}></div>
      </div>
    </div>
  );
}

/* ===================== CSS ===================== */
const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#0b0f1a",
    color: "#ffffff",
    padding: "20px",
  },

  title: {
    fontSize: "28px",
    fontWeight: "700",
    marginBottom: "20px",
  },

  card: {
    background: "#020617",
    borderRadius: "14px",
    padding: "18px",
    marginBottom: "20px",
    border: "1px solid #1e293b",
  },

  switchRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px",
  },

  switchLabel: {
    fontSize: "16px",
    fontWeight: "600",
  },

  switch: {
    width: "58px",
    height: "30px",
    borderRadius: "50px",
    display: "flex",
    alignItems: "center",
    padding: "4px",
    cursor: "pointer",
    transition: "0.3s",
  },

  knob: {
    width: "22px",
    height: "22px",
    backgroundColor: "#ffffff",
    borderRadius: "50%",
    transition: "0.3s",
  },

  label: {
    display: "block",
    marginBottom: "6px",
    fontWeight: "600",
  },

  textarea: {
    width: "100%",
    minHeight: "120px",
    padding: "10px",
    borderRadius: "8px",
    background: "#111827",
    border: "1px solid #374151",
    color: "#fff",
    outline: "none",
    resize: "vertical",
  },

  saveBtn: {
    background: "#22c55e",
    border: "none",
    padding: "12px 25px",
    borderRadius: "8px",
    fontWeight: "700",
    cursor: "pointer",
    marginTop: "10px",
  },
};